var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":['NewBoostPage']}},[_c('router-view')],1),(_vm.showTabBar)?_c('app-tab-bar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }